import React, { useEffect, useMemo, useState } from 'react';
import { Layout } from 'antd';
import { withRouter, RouteComponentProps, Link, useHistory } from 'react-router-dom';

import GlobalHeaderRight from '../GlobalHeader/RightContent';
// import logo from '../../assets/utinaPlatformLogo.png';
import styles from './index.less';
import MainMenu from './MainMenu';
import { AuthContext } from 'components/Auth/Auth';
import getEnvValue from 'utils/getEnvValue';
import Alert from 'components/Alert';

const { Header, Content } = Layout;

type AntLayoutProps = RouteComponentProps;

const pathsExcludedFromLayout = [
  '/login',
  '/posphonesshop',
  '/dashboards',
  '/init_change_password',
];

const AntLayout: React.FC<AntLayoutProps> = ({ location, children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const history = useHistory();
  const [token, setToken] = useState(() => localStorage.getItem('token'));
  const [changePassword, setchangePassword] = useState(() =>
    localStorage.getItem('changepassword')
  );
  useEffect(() => {
    const sessionExpiration = localStorage.getItem('sessionExpirationMessage');
    if (sessionExpiration) {
      try {
        
        setWarningMessage(sessionExpiration.replace('(msgid:601)',''));
          setShowWarning(true);
        
      } catch (e) {
        console.error('Error parsing sessionExpiration:', e);
      }
    }
  }, []);
  
  const handleWarningClick = () => {
    localStorage.setItem('changepassword', 'true');
    // Set in localStorage
    localStorage.setItem('changepassword', 'true');
    // Update the state directly as well
    setchangePassword('true');
        history.push('/init_change_password');
  };
  const handleCloseWarning = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowWarning(false);
  };
  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const importAll = (r: any) => {
    let images: any = {};
    r.keys().map((item: any, index: any) => {
      images[item.replace('./', '')] = r(item);
    });
    return images;
  };

  const images: any = importAll(
    require.context('../../assets/', false, /\.(png|jpg|jpe?g|svg)$/)
  );

  const isExcludedFromLayout = pathsExcludedFromLayout.includes(
    location.pathname
  );

  const LendingLogo = useMemo(
    () => (
      <div className={styles.logo}>
        <Link to="/">
          <img
            src={
              images[
                localStorage.getItem('logo') !== '' &&
                localStorage.getItem('logo') !== 'null' &&
                localStorage.getItem('logo') !== 'undefined'
                  ? localStorage.getItem('logo')
                  : getEnvValue('logo')
              ]
            }
            alt="logo"
          />
          {getEnvValue('platformetext') && <b>Platform</b>}
        </Link>
      </div>
    ),
    [localStorage.getItem('logo')]
  );

  return (
    <AuthContext.Consumer>
      {(context) =>
        !isExcludedFromLayout ? (
          
          <Layout>
            {showWarning && (
              <Alert
                variant="warning"
                className="cursor-pointer mb-4"
                onClick={handleWarningClick}
              >
                <div className="flex items-center justify-between">
                  <span>{warningMessage}</span>

                </div>
              </Alert>
            )}
            <Layout className={styles.siteLayout}>
             
              {LendingLogo}
              <Header
                className="site-layout-background"
                style={{
                  margin: collapsed ? '0px 0px 0px 80px' : '0px 0px 0px 0px',
                  padding: 0,
                  height: '60px',
                }}
              >
                <GlobalHeaderRight />
              </Header>
              <MainMenu menuFromContext={context.menu} />
              <Content
                className="site-layout-background"
                style={{
                  padding: 10,
                }}
              >
                {children}
              </Content>
            </Layout>
          </Layout>
        ) : (
          <Layout className={styles.siteLayout}>
            <Header
              className="site-layout-background"
              style={{
                margin: '0px 0px 0px 10px',
                padding: 0,
                height: '60px',
              }}
            >
              {' '}
              <GlobalHeaderRight isExcludedFromLayout={isExcludedFromLayout} />
            </Header>
            <Content
              className="site-layout-background"
              style={{
                overflow: 'scroll',
                height: '90vh',
                margin: '0px 0px 0px 0px',
                padding: 10,
                minHeight: 280,
              }}
            >
              {children}
            </Content>
          </Layout>
        )
      }
    </AuthContext.Consumer>
  );
};

export default withRouter(AntLayout);
